const guideBase = 'https://guide.freecodecamp.org/certifications';

export function createGuideUrl(slug = '') {
  // return guideBase + slug;
  const parts = slug.split('/');
  return parts[parts.length - 1];
}



// WEBPACK FOOTER //
// ./src/templates/Challenges/utils/index.js